import Seo from "@/components/Seo";
import { PageHero, Btn, DevisCta } from "@/components/Shared";
import { BookOpenCheck, Languages, Gift } from "lucide-react";

export default function DicoIA() {
  return (
    <div data-testid="page-dico-ia">
      <Seo
        title="Le petit dico de l’IA — glossaire offert de 177 termes — Form Action Pro"
        description="Le petit dico de l'IA : 177 termes expliqués simplement, 25 pages, avec les équivalents français officiels du Journal officiel et de FranceTerme. Offert."
        path="/dico-ia"
      />
      <PageHero
        kicker="Ressource offerte"
        title="Le petit dico de l’IA"
        subtitle="Le glossaire offert issu de « L’IA sans jargon » : l’essentiel du vocabulaire de l’intelligence artificielle, enfin en clair."
      />

      <section className="bg-sable py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid sm:grid-cols-3 gap-6 mb-14">
            <div className="bg-white border border-bordure rounded-lg p-8 text-center shadow-[0_2px_20px_rgba(0,0,0,0.06)]">
              <p className="font-serif text-[48px] text-vert-dark leading-none mb-3">177</p>
              <p className="font-sans text-sm text-gris-texte">termes d’IA définis simplement</p>
            </div>
            <div className="bg-white border border-bordure rounded-lg p-8 text-center shadow-[0_2px_20px_rgba(0,0,0,0.06)]">
              <p className="font-serif text-[48px] text-vert-dark leading-none mb-3">25</p>
              <p className="font-sans text-sm text-gris-texte">pages à garder sous la main</p>
            </div>
            <div className="bg-white border border-bordure rounded-lg p-8 text-center shadow-[0_2px_20px_rgba(0,0,0,0.06)]">
              <p className="font-serif text-[48px] text-vert-dark leading-none mb-3">0 €</p>
              <p className="font-sans text-sm text-gris-texte">offert, sans condition</p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="flex gap-4">
              <BookOpenCheck className="text-vert-dark shrink-0 mt-1" size={24} />
              <div>
                <h2 className="font-serif text-xl text-marine mb-2">Des définitions qui se comprennent</h2>
                <p className="font-sans text-base text-marine/80 leading-[1.7]">
                  Chaque terme est expliqué en une phrase de français courant, avec un exemple quand
                  c’est utile. Pas de jargon pour expliquer du jargon.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <Languages className="text-vert-dark shrink-0 mt-1" size={24} />
              <div>
                <h2 className="font-serif text-xl text-marine mb-2">Les équivalents français officiels</h2>
                <p className="font-sans text-base text-marine/80 leading-[1.7]">
                  Les termes anglais sont accompagnés des équivalents français officiels publiés au
                  Journal officiel et référencés par FranceTerme.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <Gift className="text-vert-dark shrink-0 mt-1" size={24} />
              <div>
                <h2 className="font-serif text-xl text-marine mb-2">Offert, contre votre e-mail</h2>
                <p className="font-sans text-base text-marine/80 leading-[1.7]">
                  Le dico vous est envoyé gratuitement : laissez simplement votre adresse e-mail sur
                  la page de téléchargement.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-14">
            <Btn
              href="https://francois-schoonheere.tinypages.co/dico-ia"
              external
              testid="dico-cta-telecharger"
              variant="primary"
            >
              Recevoir le dico gratuitement
            </Btn>
          </div>
        </div>
      </section>

      <DevisCta />
    </div>
  );
}
